import React from "react";
import "./ServicesList.css";
import { services } from "./servicesData";

function ServicesList() {
  return (
    <div className="services">
      {services.map((service, index) => (
        <section
          key={service.id}
          id={service.id}
          className={[
            "service-row",
            index % 2 === 0 ? "" : "reversed",
            // Serviços ainda sem fotografia ocupam a largura toda, em vez de
            // mostrarem uma imagem que não é da área.
            service.image ? "" : "no-image"
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {service.image && (
            <div className="service-image">
              <img src={service.image} alt={service.imageAlt} loading="lazy" />
            </div>
          )}

          <div className="service-content">
            <h2>{service.title}</h2>
            <p className="service-description">{service.description}</p>

            {service.scope?.length > 0 && (
              <>
                <h3>O que inclui</h3>
                <ul className="service-scope">
                  {service.scope.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </section>
      ))}
    </div>
  );
}

export default ServicesList;
